var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdConsentForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EFF0F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 22L35 13.1667C35 11.9707 34.076 11 32.9375 11H21.25H15.0625C13.924 11 13 11.9707 13 13.1667V34.8333C13 36.0293 13.924 37 15.0625 37H27.5",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H30.1666M18 22.2H30.1666",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26H24",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9718 31.6778L33.4913 33.1973L36.0237 29.6519M33.9977 24.9004C32.4687 26.3525 30.4323 27.1489 28.3238 27.1195C28.0556 27.9366 27.9192 28.7912 27.9199 29.6512C27.9199 33.4276 30.5023 36.6002 33.9977 37.5004C37.4932 36.6009 40.0756 33.4283 40.0756 29.6519C40.0756 28.7672 39.9338 27.9157 39.6717 27.1188H39.5691C37.4108 27.1188 35.4497 26.276 33.9977 24.9004Z",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdConsentForm);
export default __webpack_public_path__ + "static/media/sd-consent-form.43cade3aa8bf03b5e7efe253bee492c0.svg";
export { ForwardRef as ReactComponent };